var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M1.71449 18.4373H5.53267V9.16681L0.078125 5.0769V16.8013C0.078125 17.7052 0.810398 18.4373 1.71449 18.4373Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M18.624 18.4373H22.4422C23.3463 18.4373 24.0786 17.7052 24.0786 16.8013V5.0769L18.624 9.16681V18.4373Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M18.624 2.07763V9.1668L24.0786 5.07689V2.89561C24.0786 0.873831 21.7699 -0.280886 20.1513 0.932453L18.624 2.07763Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53223 9.16681V2.07764L12.0777 6.98553L18.6231 2.07764V9.16681L12.0777 14.0747L5.53223 9.16681Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M0.078125 2.89561V5.07689L5.53267 9.1668V2.07763L4.0054 0.932453C2.38676 -0.280886 0.078125 0.873831 0.078125 2.89561Z",
    fill: "#C5221F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaill);
export default __webpack_public_path__ + "static/media/maill.6980bafdc0c817161549bd6b0fdd362e.svg";
export { ForwardRef as ReactComponent };